import { CurrencyFormat, formatDate } from "../../../../components/helpers";

export const convertTopUpDeposit = (topupDeposits) => {
  let convertedTopUpDeposits = [];

  if (!topupDeposits) return [];

  topupDeposits.forEach((topupDeposit, index) => {
    convertedTopUpDeposits.push({
      key: index + 1,
      ID: topupDeposit.id,
      dateTime: formatDate(topupDeposit.date_time) || "-",
      outletName: topupDeposit.outlet_name || "-",
      requestType: topupDeposit.request_type || "-",
      amount: `Rp ${CurrencyFormat(topupDeposit.amount) || 0}`,
      remainingAmount: `Rp ${
        CurrencyFormat(topupDeposit.remaining_balance) || 0
      }`,
      state: topupDeposit.state,
    });
  });
  return convertedTopUpDeposits;
};
